import services from './services.js';
import viewPhoto from 'src/common/js/viewPhoto';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import validate from 'validate';

export default {
    mixins: [services],
    props: {
        isReadOnly: {
            default: false
        },
        isRequired: {
            default: false
        },
        value: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            defualut: false
        }
    },
    data() {
        return {
            result: this.getInitResultData(),
            cityList: [],
            areaList: [],
            showData: {}
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        }
    },
    methods: {
        // 联系人提交信息
        getInitResultData() {
            return cloneDeep({
                C_Name: '', //必填
                C_Tel: '', //必填
                ProvId: null,
                CityId: null,
                AreaId: null,
                Address: '',
                C_IDNumber_Drawing: [] //联系人身份证
            });
        },
        setValue() {
            this.result = cloneDeep($.extend({}, this.getInitResultData(), this.value));
            this.showData = this.value
        },
        // 选择省
        selfChangeProvince(provincesId) {
            if (provincesId !== null) {
                this.getCity(provincesId)
                this.$emit('ProvId', provincesId)
            }

        },
        // 选择市
        selfChangeCity(CityId) {
            if (CityId !== null) {
                this.getArea(CityId)
                this.$emit('CityId', CityId)
            }

        },
        // 选择区
        selfChangeArea(AreaId) {
            if (AreaId !== null) {
                this.$emit('AreaId', AreaId)
            }
        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "xxx", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: "xxx"
                }]
            });
        },
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },
        validate() {
            let checkRules = [{
                name: "主联系人",
                value: this.result.C_Name,
                required: true
            }, {
                name: "联系人电话",
                value: this.result.C_Tel,
                phone: true
            }, {
                name: "联系地址",
                value: this.result.ProvId,
                required: true,
                msg: "请选择联系地址"
            }, {
                name: "详细地址",
                value: this.result.Address,
                address: true
            }, {
                name: "联系人身份证",
                value: this.result.C_IDNumber_Drawing,
                required: true,
                msg: '请上传身份证照片'
            }];

            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });
            if (!flag) {
                return false;
            } else {
                return this.result;
            }
        },
        C_Nameblur() {
            $(document).unbind();
        },
        C_NameFocus() {
            $(document).unbind().keypress((e) => {
                if (e.keyCode == 32) {
                    return false;
                }
            });
        },
        resetFields() {
            //this.$refs.form.resetFields();
            this.result = this.getInitResultData();
        }
    },
    computed: {
        lxrsfzContainerId() {
            return 'lxrsfz_container_id-' + new Date().getTime();
        },
        lxrsfzBtnId() {
            return 'lxrsfz_addBtn_id-' + new Date().getTime();
        },
        provinceList() {
            return this.$store.state.allProvince
        },
    },
    mounted() {
        this.setValue();
        this.$nextTick(() => {
            util.initUploader(this, this.lxrsfzContainerId, this.lxrsfzBtnId, (file) => {
                this.result.C_IDNumber_Drawing.push(file);
            });
        });
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/agent-contactnew/vm.js